/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkMatchRequestField } from './bulkMatchRequestField';

export interface BulkMatchRequest {
  /**
     * @minItems 1
     * @maxItems 500
     */
  names: string[];
  field: BulkMatchRequestField;
}
